import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-self: end;

  @media (max-width: 968px) {
    gap: 0.6rem;
  }
`;

export const SignInButton = styled(Link)`
  background: none;
  color: #ffffff;
  border: 1.5px solid #ffffff;
  padding: 0.65rem 1.6rem;
  border-radius: 70px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.3s;

  &:hover {
    background: #ffffff;
    color: #000000;
  }

  @media (max-width: 968px) {
    display: none;
  }
`;

export const NavDropdownWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NavDropdownToggle = styled.button`
  background: none;
  border: none;
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0;
  font-family: inherit;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.7;
  }
`;

export const MegaMenuPanel = styled(motion.div)`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  background: #0a0a0a;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 2.5rem 8rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.45);
  z-index: 1050;

  @media (max-width: 968px) {
    padding: 2rem 1.5rem;
  }
`;

export const MegaMenuInner = styled.div`
  display: flex;
  gap: 3rem;
  max-width: 1320px;
`;

export const MegaMenuColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const MegaMenuColumnTitle = styled.p`
  color: #6b7280;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 0.5rem;
`;

export const MegaMenuItem = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.6rem 0.75rem;
  margin-left: -0.75rem;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

export const MegaMenuItemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const MegaMenuIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(209, 255, 148, 0.12);
  color: #d1ff94;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MegaMenuItemTitle = styled.span`
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 600;
`;

export const MegaMenuItemDesc = styled.span`
  color: #9ca3af;
  font-size: 0.8rem;
  line-height: 1.5;
`;

/* ---------- Mobile nav ---------- */

export const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  z-index: 1100;

  @media (max-width: 968px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MobileMenuOverlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1080;
`;

export const MobileMenuPanel = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 80%;
  max-width: 340px;
  background: #0a0a0a;
  padding: 5rem 2rem 2rem;
  z-index: 1090;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  overflow-y: auto;
`;

export const MobileMenuLink = styled(Link)`
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  padding: 0.5rem 0;
`;